"use strict";

var PaperProduct = require('../interfaces/PaperProduct');

module.exports = function (product, otherProductTypes, constants) {
  if (!Object.prototype.isPrototypeOf.call(PaperProduct.prototype, product)) {
    return false;
  }

  var isDoubleThick = product.paper_type.match(/double thick/i);
  var numEnclosures = 0;
  var hasWaxSeals = false;
  var hasRibbon = false;
  product.components.forEach(function (comp) {
    if (comp.component_type.match(/enclosure/i)) {
      numEnclosures++;
    }

    if (comp.wax_seal_style || otherProductTypes.includes(constants.WAX_SEALS)) {
      hasWaxSeals = true;
    }

    if (comp.acc_ribbon && !comp.acc_ribbon.match(/none/i) || comp.component_type.match(/spools/i) && parseInt(comp.quantity, 10) > 0 || otherProductTypes.includes(constants.SILK_RIBBON)) {
      hasRibbon = true;
    }
  });

  if (isDoubleThick && (hasRibbon || hasWaxSeals)) {
    return true;
  }

  if (isDoubleThick && numEnclosures > 3) {
    return true;
  }

  if (numEnclosures > 3 && (hasRibbon || hasWaxSeals)) {
    return true;
  }

  return false;
};